/*
 * go to top
 */
const goToTop = function() {

    const toTop = $('.js-to-top');

    if (toTop.length == 0) {
        return;
    }

    const toTopBtn = toTop.find('a');

    toTopBtn.click(function() {
        $('html, body').animate({scrollTop: 0}, 700, 'swing');
        return false;
    });
}


/*
 * fade to top
 */
const fadeToTop = function() {

    const toTop = $('.js-to-top');

    if (toTop.length == 0) {
        return;
    }

    if($(window).scrollTop() < 100) {
        toTop.removeClass('is-visible');

    } else {
        toTop.addClass('is-visible');
    }
}


/*
 * stop to top
 */
const stopToTop = function() {

    const toTop = $('.js-to-top');

    if (toTop.length == 0) {
        return;
    }

    const windowHeight = window.innerHeight;
    const footerPosition = $('footer').offset().top;
    const footerHeight = $('footer').outerHeight(true);
    const scroll = $(window).scrollTop();

    if (scroll > footerPosition + footerHeight - windowHeight) {
        toTop.addClass('is-stop');

    } else {
        toTop.removeClass('is-stop');
    }
}


/*
* init
*/
goToTop();
fadeToTop();
stopToTop();


/*
 * scroll event
 */
$(window).scroll(function() {

    fadeToTop();
    stopToTop();
});


/*
 * resize event
 */
$(window).resize(function() {

    fadeToTop();
    stopToTop();
});
